import gql from 'graphql-tag';

export const GET_VISITOR_SHARE = gql`
  query GetVisitorShare($params: ReportInput!) {
    safegraphVisitorShare(params: $params) {
      events {
        transactionDate
        campaignPeriod
        visitorShare
      }

      metrics {
        campaignPeriod
        avgVisitorShare
        lift
      }
    }
  }
`;

export default GET_VISITOR_SHARE;
